const isValidScope = scope => {
  if (!scope || typeof scope.selector !== 'string' || !scope.selector.startsWith('select')) {
    return false
  }

  const hasTest = typeof scope.test === 'function'
  const hasProps = typeof scope.entityProp === 'string'

  return hasTest || hasProps
}

export const prepareScope = scope => {
  if (!isValidScope(scope)) {
    if (scope) console.error('Invalid scope:', scope)
    return undefined
  }
  return {
    ...scope,
    test: scope.test || ((selection, entity) => (
      selection && entity
        && (
          scope.selectionProp
            ? selection[scope.selectionProp]
            : selection
        ) === entity[scope.entityProp])
    ),
  }
}
